const setSearch = () => {
  const selects = document.querySelectorAll('.js-search-category, .js-sort-date');

  for(const select of selects) {
    select?.addEventListener('change', function (e) {
      const option = this.options[this.selectedIndex]
      location.href = option.getAttribute('data-src')
    })
  }
}

export default setSearch;